<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="content-txt">
      <div class="t-image animate-target" v-animate-in>
        <img src="../../assets/images/Layer_1.png" />
        <div>330,000 people in Australia are living with T2D and CKD.<sup>2</sup></div>
      </div>
      <div class="p22-1 animate-target" v-animate-in>In these people, the risk of CV mortality is increased 3-fold compared with people living with T2D alone.<sup>1</sup></div>
      <div class="p22-2 animate-target" v-animate-in>Standardised 10-year cumulative incidence of CV mortality by diabetes and kidney disease status<sup>1</sup></div>
    </div>
    <div ref="target" class="charts-img2 show_animation animate-target" v-animate-in>
      <img src="../../assets/images/p2-2/chart.svg"/>
      <img src="../../assets/images/p2-2/pillar.svg"/>
      <img src="../../assets/images/p2-2/num.svg"/>
    </div>
    <GoNext class="animate-target" v-animate-in href="/section2/2-3">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";
export default {
  name: "s2-1",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{

  },
  data(){
    return {
      noticeTxt:"*10-year standardised cumulative incidence of CV mortality: 6.7% in people with T2D vs 19.6% in people with T2D and CKD. A retrospective study designed to quantify and compare the excess risk of all-cause and cause-specific mortality among people with T2D the in presence or absence of kidney disease using data from 15,046 people in the Third National Health and Nutrition Examination Survey (NHANES III) with follow-up mortality data to 2006.<br/><div class='brs'></div>"
      +"CKD, chronic kidney disease; CV, cardiovascular; T2D, type 2 diabetes<br/><br/>"
      +"References:<br/><div class='brs'></div>"
      +"1. Afkarian M, <i>et al. J Am Soc Nephrol</i> 2013;24:302–308<br/>"
      +"2. Change the future: Saving Lives by better detecting diabetes-related kidney disease. Diabetes Australia Report; 2023.",
      title:"CV mortality risk is elevated in people with T2D and CKD<sup>1</sup>"
    }
  },
  mounted() {
    this.initClassObserver(); // 组件挂载后初始化监听
  },
  beforeDestroy() {
    this.destroyObserver(); // 组件卸载前销毁监听
  },
  methods: {

    initClassObserver() {
      const targetEl = this.$refs.target;
      if (!targetEl) return;

      this.observer = new MutationObserver((mutations) => {
        console.log(mutations);
        const mutation = mutations[0];
        if (mutation.attributeName === 'class') {
          targetEl.children[1].classList.add('extend')
          targetEl.children[2].classList.add('fadeIn')
        }
      });

      const config = {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true,
      };

      this.observer.observe(targetEl, config);
    },

    // 销毁观察者（避免内存泄漏）
    destroyObserver() {
      if (this.observer) {
        this.observer.disconnect(); // 断开监听
        this.observer = null; // 清空实例
      }
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section2/s2.css";
.show_animation {
  position:relative;
}
.show_animation img:nth-child(2) {
  position:absolute;
  width: 100%;
  bottom:0px;
  left:0px;
  height:0%;
  object-fit: cover;
  object-position: bottom;
}
.show_animation img:nth-child(3) {
  position:absolute;
  width: 100%;
  bottom:0px;
  left:0px;
  object-fit: cover;
  object-position: bottom;
  opacity: 0;
}
</style>
